module.exports = __webpack_public_path__ + "BMG-512.png";